// src/components/EmptyState.jsx
import React from "react";

export default function EmptyState({ icon: Icon, title, subtitle }) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      {Icon && <Icon className="h-12 w-12 text-white mb-4" />}
      <h3 className="text-white text-lg font-semibold">{title}</h3>
      {subtitle && <p className="text-red-200 mt-2">{subtitle}</p>}
    </div>
  );
}
